
















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class LogBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly sum!: object;

  @Prop() readonly fetchDepositWithdraw!: Function;

  @Prop() readonly openDetail!: Function;

  @Prop() readonly paginationDetail!: object;

  utilsInstance = utils;

  handleSub(username, role) {
    this.fetchDepositWithdraw(username, role);
  }
}
